import { Button } from '../../components/ui/button'
import { useT } from '../../i18n'
import type { SubmissionImage } from './attachments'
import { reportCopy } from './copy'
import type { Submission } from './ReportImages'

export default function ReportVideo({ image, index, controller, editable, approved, onApproval }: {
  image: Readonly<SubmissionImage>
  index: number
  controller: Submission
  editable: boolean
  approved: boolean
  onApproval: (url: string, checked: boolean) => void
}) {
  const t = useT(reportCopy)
  return <div className="space-y-2 rounded-[var(--radius-control)] border border-[var(--color-border)] p-3">
    <p className="text-xs" role="status">{t.video} {index + 1} · {t[image.status]}</p>
    {image.previewUrl && <>
      <video src={image.previewUrl} aria-label={`${t.video} ${index + 1}`} controls playsInline preload="metadata"
        className="max-h-72 w-full rounded-[var(--radius-control)]" />
      <p className="text-xs leading-5 text-[var(--color-text-muted)]">{t.videoPrivacy}</p>
      <label className="flex min-h-11 items-center gap-2 text-sm">
        <input type="checkbox" checked={approved} disabled={!editable}
          onChange={event => onApproval(image.previewUrl!, event.target.checked)} />{t.videoReview}
      </label>
    </>}
    {image.error && <p role="alert" className="text-sm">{t.videoFailed}</p>}
    {editable && <Button variant="ghost" size="sm" onClick={() => controller.removeImage(image.key)}>{t.removeVideo}</Button>}
  </div>
}
